import { render } from "./IconTrash.vue?vue&type=template&id=5200faec&scoped=true&ts=true"
import script from "./IconTrash.vue?vue&type=script&lang=ts"
export * from "./IconTrash.vue?vue&type=script&lang=ts"

import "./IconTrash.vue?vue&type=style&index=0&id=5200faec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5200faec"]])

export default __exports__